<!-- <app-geia-button
  type="primary"
  label="Salvar"
  icon="fas fa-save"
  (click)="salvarAcao()">
</app-geia-button>

<app-geia-button
  type="danger"
  label="Cancelar"
  icon="fas fa-times"
  (click)="cancelarAcao()">
</app-geia-button>

<app-geia-button
  type="info"
  label="Ver Detalhes"
  icon="fas fa-eye"
  extraClass="btn-lg custom-class"
  (click)="detalhesAcao()">
</app-geia-button> -->
<button
  class="btn {{ extraClass }}"
  [ngClass]="{
    'cursor-not-allowed': disabled,
    'cursor-pointer': !disabled,
    'btn-primary': type === 'primary',
    'btn-secondary': type === 'secondary',
    'btn-danger': type === 'danger',
    'btn-success': type === 'success',
    'btn-info': type === 'info',
    'btn-warning': type === 'warning',
    'btn-geia-blue': type === 'geia-blue'
  }"
  [attr.disabled]="disabled ? true : null"
  (click)="handleClick()"
>
  <i *ngIf="icon" class="text-white {{ icon }}"></i>
  {{ label }}
</button>
